import { usePocQuery } from 'core/custom-hooks/use-poc-query.hook';
import { settingsKeys } from 'core/query-client/keys/settings.keys';
import { executeRequest } from 'core/utils/backend-service';
import { getExistingTrainingRegistrationMapping } from '../../service/lms-api-integration.service';
import {
    TrainingRegistrationMappingData,
    newTrainingRegistrationMappingData,
} from '../../types/lms-training-registration-mapping.type';

export const useTrainingRegistrationMapping = () =>
    usePocQuery<TrainingRegistrationMappingData>({
        queryKey: settingsKeys.lmsMapping(),
        queryFn: () =>
            executeRequest(() =>
                getExistingTrainingRegistrationMapping().then(
                    (mapping) => mapping ?? newTrainingRegistrationMappingData()
                )
            ),
    });
